// extracted by mini-css-extract-plugin
export default {"postsWrapper":"activityDrawer_postsWrapper__rZ5ZS"};